// =========================================================
// frontend/js/utils.js - Zentrale Hilfsfunktionen
// =========================================================

/**
 * Gibt den deutschen Monatsnamen eines Datums zurück
 */
window.getMonthName = function(date) {
    const months = [
        "Januar", "Februar", "März", "April", "Mai", "Juni", 
        "Juli", "August", "September", "Oktober", "November", "Dezember"
    ];
    return months[date.getMonth()];
};

/**
 * Erstellt die Initialen aus Vor- und Nachnamen (z.B. "Max Mustermann" -> "MM")
 */
window.getUserInitials = function(firstName, lastName) {
    if (!firstName && !lastName) return "??";
    const f = firstName ? firstName[0] : "";
    const l = lastName ? lastName[0] : "";
    return (f + l).toUpperCase();
};

/**
 * Generiert das HTML für das runde Profilbild (Avatar)
 */
window.getAvatarHTML = function(user, classes = "w-8 h-8 text-sm") {
    if (!user) return `<div class="${classes} rounded-full bg-slate-200 text-slate-500 flex items-center justify-center font-bold">?</div>`;
    const initials = window.getUserInitials(user.firstName, user.lastName);
    return `<div class="${classes} rounded-full bg-blue-600 text-white flex items-center justify-center font-bold shadow-sm ring-2 ring-white">${initials}</div>`;
};

/**
 * Formatiert ein JS-Date Objekt zu YYYY-MM-DD (Wichtig für Firebase & Datenbankabgleiche)
 */
window.formatDate = function(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
};